const captalizeWords = (value) => {
  const strWords = String(value)
  const arrWords = strWords.split(' ')
  const arrWordsCap = arrWords.map( (word)=> word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() )
  console.log(arrWordsCap)
  return arrWordsCap.join(' ')
}

export default captalizeWords